// extracted by mini-css-extract-plugin
module.exports = {"modal":"ErrorModal_modal__9ixA7","modalContent":"ErrorModal_modalContent__3f-9n","errorMessage":"ErrorModal_errorMessage__3qwMh","closeButton":"ErrorModal_closeButton__3RCbu"};